import "@/App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Event from "./pages/Event";
import RSVP from "./pages/RSVP";
import Stay from "./pages/Stay";
import OtherHotels from "./pages/OtherHotels";
import Travel from "./pages/Travel";
import ThingsToDo from "./pages/ThingsToDo";
import FAQ from "./pages/FAQ";
import WhosGoing from "./pages/WhosGoing";
import Admin from "./pages/Admin";

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/event", element: <Event /> },
      { path: "/rsvp", element: <RSVP /> },
      { path: "/stay", element: <Stay /> },
      { path: "/hotels", element: <OtherHotels /> },
      { path: "/travel", element: <Travel /> },
      { path: "/do", element: <ThingsToDo /> },
      { path: "/whos-going", element: <WhosGoing /> },
      { path: "/faq", element: <FAQ /> },
      { path: "/admin", element: <Admin /> },
    ],
  },
]);

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
